import React, { useEffect, useRef } from 'react';
import './ConfirmationModal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string | React.ReactNode; // ← CAMBIO AQUÍ
  onConfirm: () => void;
  onCancel: () => void;
  isProcessing?: boolean;
}

function ConfirmationModal({ isOpen, title, message, onConfirm, onCancel, isProcessing}: ConfirmationModalProps) {
  const confirmButtonRef = useRef<HTMLButtonElement | null>(null);
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyPress = (e: KeyboardEvent) => {
      e.stopPropagation();

      if (e.key === 'Escape') {
        onCancel();
      } else if (e.shiftKey) {
        e.preventDefault();
        if (confirmButtonRef.current) {
          confirmButtonRef.current.click();
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress, true);
    return () => {
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="modal-confirmation-overlay">
      <div className="modal-confirmation-container">
        <h3 className="modal-title">
          <i className="fas fa-exclamation-circle"></i> {title}
        </h3>
        {/* ← CAMBIO AQUÍ: usar div en lugar de p para soportar ReactNode */}
        <div className="modal-message">{message}</div>
        <div className="modal-buttons">
          <button 
            onClick={onCancel} 
            className="modal-cancel-btn" 
            ref={cancelButtonRef}
          >
            <i className="fas fa-times-circle"></i> Cancelar
          </button>
          <button 
            onClick={onConfirm} 
            className="modal-confirm-btn" 
            ref={confirmButtonRef}
            disabled={isProcessing}
          >
            {isProcessing ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <i className="fas fa-check-circle"></i>
            )} Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;